(() => {
  const patch = () => {
    const C = customElements.get('cart-drawer');
    if (!C) return false;

    C.prototype.getSectionsToRender ??= function () {
      return [
        { section: 'atlas-cart-drawer', selector: '#CartDrawer' },
        { id: 'cart-icon-bubble', section: 'atlas-cart-icon-bubble' }
      ];
    };

    C.prototype.setActiveElement ??= function (element) {
      this.activeElement = element;
    };

    return true;
  };

  if (!patch()) {
    customElements.whenDefined('cart-drawer').then(patch);
  }
})();
(() => {
  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) return;

      const productForm = form.closest('product-form');

      // Appliquer uniquement au formulaire produit Atlas
      if (
        !productForm ||
        !productForm.closest('.atlas-isolation-wrapper') ||
        !form.action.includes('/cart/add')
      ) {
        return;
      }

      // Bloquer le script panier Atlas incompatible
      event.preventDefault();
      event.stopImmediatePropagation();

      const submitButton = form.querySelector('[type="submit"]');

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }

      try {
        const formData = new FormData(form);
        const variantInput = productForm.querySelector('[name="id"]');

        if (!formData.get('id') && variantInput?.value) {
          formData.set('id', variantInput.value);
        }

        if (!formData.get('id')) {
          throw new Error('No valid product variant was found.');
        }

        const root = window.Shopify?.routes?.root || '/';
        const addUrl = window.routes?.cart_add_url || `${root}cart/add.js`;

        const response = await fetch(addUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData,
          credentials: 'same-origin'
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
            result.message ||
            'The product could not be added to the cart.'
          );
        }

        const cartUrl = window.routes?.cart_url || `${root}cart`;
        window.location.assign(cartUrl);
      } catch (error) {
        console.error('VYNTORA cart error:', error);
        alert(error.message);

        if (submitButton) {
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-busy');
        }
      }
    },
    true
  );
})();